// frontend/src/views/AccessHashHandler.jsx

import { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

export default function AccessHashHandler() {
  const { hash } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (hash && (hash.startsWith('inv_') || hash.startsWith('grp_'))) {
      // guardar hash para el EntryPoint
      sessionStorage.setItem('incoming_hash', hash);

      // 🔹 leer identificador desde query param
      const params = new URLSearchParams(location.search);
      const identifier = params.get('i');

      if (identifier) {
       sessionStorage.setItem('incoming_identifier', identifier);
      }
    }

    // redirigir al flujo normal
    navigate('/');
  }, [hash, navigate, location.search]);

  return null;
}